import { BASE_URL } from "../../Constant";

export const API_URL_IS_URL_EXIST : string = BASE_URL + '/api/url/isUrlExist';
export const API_URL_DOES_URL_EXIST : string = BASE_URL + '/api/url/doesUrlExist';